// src/components/Navbar.jsx
import React from "react";
import { Link } from "react-router-dom";

function Navbar({ darkMode }) {
  return (
    <nav
      className={`navbar navbar-expand-lg ${
        darkMode ? "navbar-dark bg-dark" : "navbar-light bg-light"
      } fixed-top`}
    >
      <div className="container">
        <Link className="navbar-brand" to="/">
          ETACS Tutorial
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto">
            {/* 
              Se quiser um link explicitamente escrito "Tutorial", pode mantê-lo,
              mas ele vai apontar para "/", que já é a principal:
            */}
            {/* <li className="nav-item">
              <Link className="nav-link" to="/">Tutorial</Link>
            </li> */}

            <li className="nav-item">
              <Link className="nav-link" to="/downloads">
                Downloads
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/faq">
                FAQ
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
